import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translation from './translations'

Vue.use(VueI18n)

if (!localStorage.getItem('lang') || localStorage.getItem('lang') === 'cs') {
    VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
        choice = Math.abs(choice)
        if (choice === 0) {
            return 2
        } else if (choice === 1) {
            return 0
        } else if (choice < 5) {
            return 1
        } else {
            return 2
        }
    }
}

export default new VueI18n({
    locale: localStorage.getItem('lang') || 'cs',
    messages: translation
})
